// import React, { useEffect } from 'react'
// import { Box, List, ListItem, Typography } from '@mui/material'
// import { AppName, DisclaimerTitle } from '@utils'

// const Disclaimer = () => {
//     useEffect(() => {
//         document.title = `${AppName} | ${DisclaimerTitle}`
//     }, [])

//     return (
//         <Box bgcolor={'white'} p={2} pr={4} pt={4} pb={4} borderRadius={1} boxShadow={1} textAlign={'justify'}>
//             <Typography pl={2}>Nutzungsbedingungen und rechtliche Hinweise zur Online-Plattform Priceblick (Disclaimer)</Typography>
//             <List sx={{ listStyle: "decimal", pl: 4 }}>
//                 <Box>
//                     <ListItem sx={{ display: "list-item", fontWeight: "bold" }}>
//                         Anwendungsbereich
//                     </ListItem>
//                     <Typography className='pl-4'>
//                         Die folgenden Bestimmungen regeln die allgemeinen Bedingungen zur Nutzung der Online-Plattform "Priceblick".
//                         Mit Unterzeichnung der Nutzungsbedingungen bzw. der ersten Verwendung der Online-Plattform Priceblick" anerkennt der
//                         Nutzer die vorliegenden Nutzungsbedingungen und Haftungsausschlüsse ausdrücklich und vorbehaltlos. Die Nutzungsbedingungen
//                         gelten während der gesamten Nutzungsdauer. Diese beginnt mit der Errichtung des Zugangs und endet mit dessen Deaktivierung
//                     </Typography>
//                 </Box>
//                 <Box>
//                     <ListItem sx={{ display: "list-item", fontWeight: "bold" }}>
//                         Zugangsberechtigung zur Online-Plattform
//                     </ListItem>
//                     <Typography className='pl-4'>
//                         Für den Zugang zum Priceblick ist eine Legitimation über ein von CKW abgegebenes Log-In erforderlich. Das Log-In wird nur
//                         Geschäftskunden, das heisst juristischen Personen und deren Mitarbeitern gewährt. Um Zugang zum Priceblick zu erhalten,
//                         muss sich der Mitarbeiter des Kunden mit den individuell zugeteilten Log-In Daten anmelden. CKW kann die erforderlichen
//                         Log-In Daten jederzeit ergänzen oder ändern.
//                     </Typography>
//                 </Box>
//                 <Box>
//                     <ListItem sx={{ display: "list-item", fontWeight: "bold" }}>
//                         Pflichten des Kunden
//                     </ListItem>
//                     <Typography className='pl-4'>
//                         Der Kunde ist für die rechtmässige Verwendung des Log-Ins durch die berechtigten Mitarbeiter selbst verantwortlich.
//                         Der Kunde verpflichtet sich zur Mitwirkung an der Erfassung oder Mutation aller für den optimalen Betrieb von Priceblick
//                         notwendigen Daten und meldet Änderungen (insb. Nutzerverwaltung) rechtzeitig an CKW. Diese ist ausschliesslich befugt,
//                         die gemeldeten Daten administrativ einzupflegen. Die Log-In-Daten sind geheim zu halten und gegen missbräuchliche
//                         Verwendung und Verwendung durch Unbefugte zu schützen. Der Kunde trägt sämtliche Folgen, die sich aus der Verwendung seiner
//                         Identifikationsmerkmale ergeben. Der technische Zugang inklusive der dazu erforderlichen Hard- und Software ist Sache des Kunden.
//                         Die technischen Voraussetzungen können jederzeit ändern. Der Kunde ist dafür verantwortlich, dass die in seinem Einflussbereich
//                         liegende Hard- und Software dem sich ändernden technischen Umfeld angepasst werden.
//                     </Typography>
//                 </Box>
//                 <Box>
//                     <ListItem sx={{ display: "list-item", fontWeight: "bold" }}>
//                         Zustandekommen eines Handelsgeschäfts
//                     </ListItem>
//                     <Typography className='pl-4'>
//                         Der Kunde versendet über die Online-Plattform eine Anfrage, welche automatisiert bestätigt wird. Ein Geschäft gilt erst dann als
//                         bestätigt und zustande gekommen, wenn der Kunde eine manuelle Bestätigung des Händlers erhält. Bis zu diesem Zeitpunkt kann CKW
//                         das Geschäft jederzeit ablehnen.
//                     </Typography>
//                 </Box>
//                 <Box>
//                     <ListItem sx={{ display: "list-item", fontWeight: "bold" }}>
//                         Verfügbarkeit der Online-Plattform
//                     </ListItem>
//                     <Typography className='pl-4'>
//                         CKW übernimmt keinerlei Gewährleistung für die unterbrechungsfreie Funktionstüchtigkeit, Vollständigkeit, Richtigkeit
//                         und Zuverlässigkeit von Priceblick und der darin aufbereiteten Daten. Bei der Feststellung von Sicherheitsrisiken ist CKW zudem
//                         jederzeit berechtigt, den Zugang zu Priceblick zu unterbrechen oder vollständig einzustellen. Aus der rechtmässigen Unterbrechung
//                         oder Einstellung des Zugangs entsteht dem Nutzer kein Anspruch auf Entschädigung irgendwelcher Art.
//                     </Typography>
//                 </Box>
//                 <Box>
//                     <ListItem sx={{ display: "list-item", fontWeight: "bold" }}>
//                         Haftungsausschluss
//                     </ListItem>
//                     <Typography className='pl-4'>
//                         CKW haftet nicht für allfällige Schäden, welchem dem Nutzer durch unsachgemässe Benutzung von Priceblick und die Verletzung
//                         der vorgenannten (vgl. Ziff. 3) Pflichten, insbesondere der Verwendung von Priceblick durch Unberechtigte entstehen und behält sich vor,
//                         allfällige CKW entstandene Schäden gegenüber dem Kunden geltend zu machen. CKW übernimmt weiter keine Haftung für Schäden,
//                         welche dem Kunden aufgrund der Verwendung der in Priceblick zur Verfügung gestellten Daten oder Informationen entstanden sind.
//                     </Typography>
//                 </Box>
//                 <Box>
//                     <ListItem sx={{ display: "list-item", fontWeight: "bold" }}>
//                         Datenschutz
//                     </ListItem>
//                     <Typography className='pl-4'>
//                         Der Nutzer verpflichtet sich, über alle Tatsachen und Informationen Stillschweigen zu bewahren, die ausdrücklich als geschützt oder
//                         vertraulich oder in anderer Weise schriftlich gekennzeichnet worden sind oder die aus den Umständen ihrer Offenlegung nach Treu und
//                         Glauben als geschützt oder vertraulich angesehen werden müssen. Als vertraulich gelten insbesondere Struktur und Inhalt der im Rahmen
//                         von Priceblick angebotenen Dienstleistungen sowie sämtliche darüber dem Kunden zugänglich gemachten Marktinformationen
//                     </Typography>
//                     <List sx={{ listStyle: "lower-alpha", pl: 8 }}>
//                         <Box>
//                             <ListItem sx={{ display: "list-item", fontWeight: "bold" }}>
//                                 Automatisch gespeicherte Daten
//                             </ListItem>
//                             <Typography pl={2}>
//                                 Durch den Besuch von Priceblick werden automatisch Daten in Logfiles gespeichert. Namentlich sind dies die IP-Adresse des Kunden bzw.
//                                 die IP-Adresse seines Internet Service Providers, die Einstiegsseite (von welcher der Kunde auf das Serviceportal gestossen ist), der Browsertyp,
//                                 das Betriebssystem und die Plattform, Zugriffszeiten und Datum (nachfolgend «Verbindungsdaten»). Diese Verbindungsdaten sollen
//                                 Aufschluss darüber geben, wie Besucher Priceblick nutzen; sie werden für statistische Zwecke ausgewertet und für interne Massnahmen zur
//                                 Qualitätsverbesserung verwendet. Der Kunde bzw. der jeweilige Nutzer willigt ein, dass sie darüber hinaus verwendet werden können,
//                                 um ihm individualisierte Angebote und Produktinformationen zuzustellen. CKW verwendet so genannte Cookies, um die Qualität ihrer
//                                 Dienstleistungen zu verbessern und um besser verstehen zu können, wie die Besucher diese Website nutzen.
//                             </Typography>
//                         </Box>
//                         <Box>
//                             <ListItem sx={{ display: "list-item", fontWeight: "bold" }}>
//                                 Erhebung, Verarbeitung und Weitergabe von persönlichen Daten
//                             </ListItem>
//                             <Box pl={2}>
//                                 <Typography>
//                                     Beim Verwenden von Priceblick werden Informationen zur Person des Kunden an CKW übermittelt (wie z.B. Name, Kontaktdaten, E-Mail-Adresse).
//                                     Eine entsprechende Übermittlung erfolgt etwa durch das Registrieren beim Log-In. Mit der Übermittlung seiner Daten an CKW erklärt sich der
//                                     Kunde damit einverstanden, dass die Daten zum Zwecke des Betriebs von Priceblick von CKW sowie damit im Zusammenhang stehender
//                                     Dienstleistungen von CKW gespeichert und bearbeitet werden. Darüber hinaus willigt der Kunde bzw. der jeweilige Nutzer ein,
//                                     dass sie darüber hinaus verwendet werden können, um ihm individualisierte Angebote und Produktinformationen zuzustellen.
//                                 </Typography>
//                                 <Typography>
//                                     Die Datenbearbeitung erfolgt durch CKW oder durch die Priceblick Ltd (Hoster des Serviceportals). Die Datenübermittlung und Datenhaltung
//                                     erfolgt somit ausschliesslich in Ländern, die gemäss Liste des Eidgenössischen Datenschutzbeauftragten über
//                                     ein angemessenes Datenschutzniveau verfügen.
//                                 </Typography>
//                                 <Typography>
//                                     Die persönlichen Daten des Kunden werden weder an Dritte verkauft noch werden sie grundsätzlich mit Dritten ausserhalb der
//                                     CKW-Gruppe geteilt. Vorbehalten bleibt die Weitergabe der Daten durch CKW an externe Unternehmen oder Vertreter zur Erbringung
//                                     von Dienstleistungen für CKW und zu den oben erwähnten Zwecken. Diese Unternehmen und Vertreter sind verpflichtet, sich bei der
//                                     Nutzung der persönlichen Daten an die geltenden Gesetze und unsere Datenschutzbestimmungen zu halten. Im Weiteren wird CKW die
//                                     Personendaten gegenüber sonstigen Dritten nur bekannt geben, sofern und soweit dies nach geltendem Gesetz, gerichtlicher Verfügungen
//                                     oder behördlicher Regulierung vorgeschrieben ist.
//                                 </Typography>
//                             </Box>
//                         </Box>
//                         <Box>
//                             <ListItem sx={{ display: "list-item", fontWeight: "bold" }}>
//                                 Datenübertragung und -sicherheit
//                             </ListItem>
//                             <Typography pl={2}>
//                                 Der Kunde ist sich bewusst, dass das Internet ein offenes, für jedermann zugängliches Netz ist und im Allgemeinen nicht als sichere
//                                 Umgebung gilt. Demnach können die Personendaten des Kunden während der Übertragung über das Internet womöglich verloren gehen oder von
//                                 unberechtigten Dritten abgefangen und ohne seine Zustimmung gesammelt bzw. genutzt werden. Folglich kann dies dazu führen, dass Personendaten
//                                 offengelegt oder inhaltlich verändert werden. Zudem können über das Internet versendete Daten grenzüberschreitend, falls er dies aus
//                                 Gründen der Sicherheit für angemessen erachtet. Für die auf dem Priceblick gespeicherten Personendaten des Kunden gewährleistet CKW
//                                 eine den gesetzlichen Vorgaben entsprechende Datensicherheit.
//                             </Typography>
//                         </Box>
//                     </List>
//                 </Box>
//                 <Box>
//                     <ListItem sx={{ display: "list-item", fontWeight: "bold" }}>
//                         Vertraulichkeit
//                     </ListItem>
//                     <Typography className='pl-4'>
//                         CKW legt Wert auf den Schutz der Privatsphäre der Nutzer von Priceblick und verwendet deren persönliche Daten gemäss der
//                         jeweils geltenden Datenschutzgesetzgebung. Die nachfolgende Datenschutzerklärung gibt Auskunft darüber, wie CKW mit Personendaten
//                         der Nutzer umgeht, die beim Besuch von Priceblick erhoben werden.
//                     </Typography>
//                 </Box>
//                 <Box>
//                     <ListItem sx={{ display: "list-item", fontWeight: "bold" }}>
//                         Weitere Bestimmungen
//                     </ListItem>
//                     <Typography className='pl-4'>
//                         CKW behält sich vor, die vorliegenden Nutzungsbedingungen jederzeit anzupassen. Sie gelten ohne schriftlichen Widerspruch mit der
//                         nächsten Nutzung des Online-Portals als genehmigt. Ausschliesslicher Gerichtsstand für alle sich aus oder im Zusammenhang mit der
//                         Nutzung von Priceblick ergebenden Streitigkeiten ist Luzern.
//                     </Typography>
//                 </Box>
//             </List>
//             <Box pl={6} mt={2}>
//                 <Typography>Centralschweizerische Kraftwerke AG</Typography>
//                 <Typography>Luzern, Dezember 2017</Typography>
//             </Box>
//         </Box>
//     )
// }

// export default Disclaimer

import React, { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import { AppName, DisclaimerTitle } from '@utils';

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`disclaimer-tabpanel-${index}`}
            aria-labelledby={`disclaimer-tab-${index}`}
            {...other}
        >
            {value === index && <Box>{children}</Box>}
        </div>
    );
}

function TermsOfUseContent() {
    return (
        <Box bgcolor={'white'} p={2} pr={4} pt={4} pb={4} borderRadius={1} boxShadow={1} textAlign={'justify'}>
            <Typography pl={2} variant="h6" gutterBottom>
                Nutzungsbedingungen und rechtliche Hinweise zur Online-Plattform Priceblick (Disclaimer)
            </Typography>
            <List sx={{ listStyle: "decimal", pl: 4 }}>
                <Box>
                    <ListItem sx={{ display: "list-item", fontWeight: "bold" }}>
                        Anwendungsbereich
                    </ListItem>
                    <Typography className='pl-4'>
                        Die folgenden Bestimmungen regeln die allgemeinen Bedingungen zur Nutzung der Online-Plattform "Priceblick".
                        Mit Unterzeichnung der Nutzungsbedingungen bzw. der ersten Verwendung der Online-Plattform Priceblick" anerkennt der
                        Nutzer die vorliegenden Nutzungsbedingungen und Haftungsausschlüsse ausdrücklich und vorbehaltlos. Die Nutzungsbedingungen
                        gelten während der gesamten Nutzungsdauer. Diese beginnt mit der Errichtung des Zugangs und endet mit dessen Deaktivierung.
                    </Typography>
                </Box>
                <Box>
                    <ListItem sx={{ display: "list-item", fontWeight: "bold" }}>
                        Zugangsberechtigung zur Online-Plattform
                    </ListItem>
                    <Typography className='pl-4'>
                        Für den Zugang zum Priceblick ist eine Legitimation über ein von CKW abgegebenes Log-In erforderlich. Das Log-In wird nur
                        Geschäftskunden, das heisst juristischen Personen und deren Mitarbeitern gewährt. Um Zugang zum Priceblick zu erhalten,
                        muss sich der Mitarbeiter des Kunden mit den individuell zugeteilten Log-In Daten anmelden. CKW kann die erforderlichen
                        Log-In Daten jederzeit ergänzen oder ändern.
                    </Typography>
                </Box>
                <Box>
                    <ListItem sx={{ display: "list-item", fontWeight: "bold" }}>
                        Pflichten des Kunden
                    </ListItem>
                    <Typography className='pl-4'>
                        Der Kunde ist für die rechtmässige Verwendung des Log-Ins durch die berechtigten Mitarbeiter selbst verantwortlich.
                        Der Kunde verpflichtet sich zur Mitwirkung an der Erfassung oder Mutation aller für den optimalen Betrieb von Priceblick
                        notwendigen Daten und meldet Änderungen (insb. Nutzerverwaltung) rechtzeitig an CKW. Diese ist ausschliesslich befugt,
                        die gemeldeten Daten administrativ einzupflegen. Die Log-In-Daten sind geheim zu halten und gegen missbräuchliche
                        Verwendung und Verwendung durch Unbefugte zu schützen. Der Kunde trägt sämtliche Folgen, die sich aus der Verwendung seiner
                        Identifikationsmerkmale ergeben. Der technische Zugang inklusive der dazu erforderlichen Hard- und Software ist Sache des Kunden.
                        Die technischen Voraussetzungen können jederzeit ändern. Der Kunde ist dafür verantwortlich, dass die in seinem Einflussbereich
                        liegende Hard- und Software dem sich ändernden technischen Umfeld angepasst werden.
                    </Typography>
                </Box>
                <Box>
                    <ListItem sx={{ display: "list-item", fontWeight: "bold" }}>
                        Zustandekommen eines Handelsgeschäfts
                    </ListItem>
                    <Typography className='pl-4'>
                        Der Kunde versendet über die Online-Plattform eine Anfrage, welche automatisiert bestätigt wird. Ein Geschäft gilt erst dann als
                        bestätigt und zustande gekommen, wenn der Kunde eine manuelle Bestätigung des Händlers erhält. Bis zu diesem Zeitpunkt kann CKW
                        das Geschäft jederzeit ablehnen.
                    </Typography>
                </Box>
                <Box>
                    <ListItem sx={{ display: "list-item", fontWeight: "bold" }}>
                        Verfügbarkeit der Online-Plattform
                    </ListItem>
                    <Typography className='pl-4'>
                        CKW übernimmt keinerlei Gewährleistung für die unterbrechungsfreie Funktionstüchtigkeit, Vollständigkeit, Richtigkeit
                        und Zuverlässigkeit von Priceblick und der darin aufbereiteten Daten. Bei der Feststellung von Sicherheitsrisiken ist CKW zudem
                        jederzeit berechtigt, den Zugang zu Priceblick zu unterbrechen oder vollständig einzustellen. Aus der rechtmässigen Unterbrechung
                        oder Einstellung des Zugangs entsteht dem Nutzer kein Anspruch auf Entschädigung irgendwelcher Art.
                    </Typography>
                </Box>
                <Box>
                    <ListItem sx={{ display: "list-item", fontWeight: "bold" }}>
                        Haftungsausschluss
                    </ListItem>
                    <Typography className='pl-4'>
                        CKW haftet nicht für allfällige Schäden, welchem dem Nutzer durch unsachgemässe Benutzung von Priceblick und die Verletzung
                        der vorgenannten (vgl. Ziff. 3) Pflichten, insbesondere der Verwendung von Priceblick durch Unberechtigte entstehen und behält sich vor,
                        allfällige CKW entstandene Schäden gegenüber dem Kunden geltend zu machen. CKW übernimmt weiter keine Haftung für Schäden,
                        welche dem Kunden aufgrund der Verwendung der in Priceblick zur Verfügung gestellten Daten oder Informationen entstanden sind.
                    </Typography>
                </Box>
                <Box>
                    <ListItem sx={{ display: "list-item", fontWeight: "bold" }}>
                        Datenschutz
                    </ListItem>
                    <Typography className='pl-4'>
                        Der Nutzer verpflichtet sich, über alle Tatsachen und Informationen Stillschweigen zu bewahren, die ausdrücklich als geschützt oder
                        vertraulich oder in anderer Weise schriftlich gekennzeichnet worden sind oder die aus den Umständen ihrer Offenlegung nach Treu und
                        Glauben als geschützt oder vertraulich angesehen werden müssen. Als vertraulich gelten insbesondere Struktur und Inhalt der im Rahmen
                        von Priceblick angebotenen Dienstleistungen sowie sämtliche darüber dem Kunden zugänglich gemachten Marktinformationen.
                    </Typography>
                    <List sx={{ listStyle: "lower-alpha", pl: 8 }}>
                        <Box>
                            <ListItem sx={{ display: "list-item", fontWeight: "bold" }}>
                                Automatisch gespeicherte Daten
                            </ListItem>
                            <Typography pl={2}>
                                Durch den Besuch von Priceblick werden automatisch Daten in Logfiles gespeichert. Namentlich sind dies die IP-Adresse des Kunden bzw.
                                die IP-Adresse seines Internet Service Providers, die Einstiegsseite (von welcher der Kunde auf das Serviceportal gestossen ist), der Browsertyp,
                                das Betriebssystem und die Plattform, Zugriffszeiten und Datum (nachfolgend «Verbindungsdaten»). Diese Verbindungsdaten sollen
                                Aufschluss darüber geben, wie Besucher Priceblick nutzen; sie werden für statistische Zwecke ausgewertet und für interne Massnahmen zur
                                Qualitätsverbesserung verwendet. Der Kunde bzw. der jeweilige Nutzer willigt ein, dass sie darüber hinaus verwendet werden können,
                                um ihm individualisierte Angebote und Produktinformationen zuzustellen. CKW verwendet so genannte Cookies, um die Qualität ihrer
                                Dienstleistungen zu verbessern und um besser verstehen zu können, wie die Besucher diese Website nutzen.
                            </Typography>
                        </Box>
                        <Box>
                            <ListItem sx={{ display: "list-item", fontWeight: "bold" }}>
                                Erhebung, Verarbeitung und Weitergabe von persönlichen Daten
                            </ListItem>
                            <Box pl={2}>
                                <Typography>
                                    Beim Verwenden von Priceblick werden Informationen zur Person des Kunden an CKW übermittelt (wie z.B. Name, Kontaktdaten, E-Mail-Adresse).
                                    Eine entsprechende Übermittlung erfolgt etwa durch das Registrieren beim Log-In. Mit der Übermittlung seiner Daten an CKW erklärt sich der
                                    Kunde damit einverstanden, dass die Daten zum Zwecke des Betriebs von Priceblick von CKW sowie damit im Zusammenhang stehender
                                    Dienstleistungen von CKW gespeichert und bearbeitet werden. Darüber hinaus willigt der Kunde bzw. der jeweilige Nutzer ein,
                                    dass sie darüber hinaus verwendet werden können, um ihm individualisierte Angebote und Produktinformationen zuzustellen.
                                </Typography>
                                <Typography>
                                    Die Datenbearbeitung erfolgt durch CKW oder durch die Priceblick Ltd (Hoster des Serviceportals). Die Datenübermittlung und Datenhaltung
                                    erfolgt somit ausschliesslich in Ländern, die gemäss Liste des Eidgenössischen Datenschutzbeauftragten über
                                    ein angemessenes Datenschutzniveau verfügen.
                                </Typography>
                                <Typography>
                                    Die persönlichen Daten des Kunden werden weder an Dritte verkauft noch werden sie grundsätzlich mit Dritten ausserhalb der
                                    CKW-Gruppe geteilt. Vorbehalten bleibt die Weitergabe der Daten durch CKW an externe Unternehmen oder Vertreter zur Erbringung
                                    von Dienstleistungen für CKW und zu den oben erwähnten Zwecken. Diese Unternehmen und Vertreter sind verpflichtet, sich bei der
                                    Nutzung der persönlichen Daten an die geltenden Gesetze und unsere Datenschutzbestimmungen zu halten. Im Weiteren wird CKW die
                                    Personendaten gegenüber sonstigen Dritten nur bekannt geben, sofern und soweit dies nach geltendem Gesetz, gerichtlicher Verfügungen
                                    oder behördlicher Regulierung vorgeschrieben ist.
                                </Typography>
                            </Box>
                        </Box>
                        <Box>
                            <ListItem sx={{ display: "list-item", fontWeight: "bold" }}>
                                Datenübertragung und -sicherheit
                            </ListItem>
                            <Typography pl={2}>
                                Der Kunde ist sich bewusst, dass das Internet ein offenes, für jedermann zugängliches Netz ist und im Allgemeinen nicht als sichere
                                Umgebung gilt. Demnach können die Personendaten des Kunden während der Übertragung über das Internet womöglich verloren gehen oder von
                                unberechtigten Dritten abgefangen und ohne seine Zustimmung gesammelt bzw. genutzt werden. Folglich kann dies dazu führen, dass Personendaten
                                offengelegt oder inhaltlich verändert werden. Zudem können über das Internet versendete Daten grenzüberschreitend, falls er dies aus
                                Gründen der Sicherheit für angemessen erachtet. Für die auf dem Priceblick gespeicherten Personendaten des Kunden gewährleistet CKW
                                eine den gesetzlichen Vorgaben entsprechende Datensicherheit.
                            </Typography>
                        </Box>
                    </List>
                </Box>
                <Box>
                    <ListItem sx={{ display: "list-item", fontWeight: "bold" }}>
                        Vertraulichkeit
                    </ListItem>
                    <Typography className='pl-4'>
                        CKW legt Wert auf den Schutz der Privatsphäre der Nutzer von Priceblick und verwendet deren persönliche Daten gemäss der
                        jeweils geltenden Datenschutzgesetzgebung. Die nachfolgende Datenschutzerklärung gibt Auskunft darüber, wie CKW mit Personendaten
                        der Nutzer umgeht, die beim Besuch von Priceblick erhoben werden.
                    </Typography>
                </Box>
                <Box>
                    <ListItem sx={{ display: "list-item", fontWeight: "bold" }}>
                        Weitere Bestimmungen
                    </ListItem>
                    <Typography className='pl-4'>
                        CKW behält sich vor, die vorliegenden Nutzungsbedingungen jederzeit anzupassen. Sie gelten ohne schriftlichen Widerspruch mit der
                        nächsten Nutzung des Online-Portals als genehmigt. Ausschliesslicher Gerichtsstand für alle sich aus oder im Zusammenhang mit der
                        Nutzung von Priceblick ergebenden Streitigkeiten ist Luzern.
                    </Typography>
                </Box>
            </List>
            <Box pl={6} mt={2}>
                <Typography>Centralschweizerische Kraftwerke AG</Typography>
                <Typography>Luzern, Dezember 2017</Typography>
            </Box>
        </Box>
    );
}

function PrivacyPolicyContent() {
    return (
        <Box bgcolor={'white'} p={2} pr={4} pt={4} pb={4} borderRadius={1} boxShadow={1} textAlign={'justify'}>
            <Typography pl={2} variant="h6" gutterBottom>
                Datenschutzerklärung
            </Typography>
            <List sx={{ listStyle: "decimal", pl: 4 }}>
                <Box>
                    <ListItem sx={{ display: "list-item", fontWeight: "bold" }}>
                        Allgemeine Informationen
                    </ListItem>
                    <Typography className='pl-4'>
                        CKW legt Wert auf den Schutz der Privatsphäre der Nutzer von Priceblick und verwendet deren persönliche Daten gemäss der
                        jeweils geltenden Datenschutzgesetzgebung. Die nachfolgende Datenschutzerklärung gibt Auskunft darüber, wie CKW mit Personendaten
                        der Nutzer umgeht, die beim Besuch von Priceblick erhoben werden.
                    </Typography>
                </Box>
                <Box>
                    <ListItem sx={{ display: "list-item", fontWeight: "bold" }}>
                        Erhebung und Verarbeitung von persönlichen Daten
                    </ListItem>
                    <Typography className='pl-4'>
                        Beim Verwenden von Priceblick werden Informationen zur Person des Kunden an CKW übermittelt (wie z.B. Name, Kontaktdaten, E-Mail-Adresse).
                        Eine entsprechende Übermittlung erfolgt etwa durch das Registrieren beim Log-In. Mit der Übermittlung seiner Daten an CKW erklärt sich der
                        Kunde damit einverstanden, dass die Daten zum Zwecke des Betriebs von Priceblick von CKW sowie damit im Zusammenhang stehender
                        Dienstleistungen von CKW gespeichert und bearbeitet werden.
                    </Typography>
                </Box>
                <Box>
                    <ListItem sx={{ display: "list-item", fontWeight: "bold" }}>
                        Verwendung der persönlichen Daten
                    </ListItem>
                    <Typography className='pl-4'>
                        Die erhobenen persönlichen Daten werden für folgende Zwecke verwendet:
                    </Typography>
                    <List sx={{ listStyle: "lower-alpha", pl: 8 }}>
                        <ListItem sx={{ display: "list-item" }}>
                            <Typography>Betrieb und Wartung von Priceblick</Typography>
                        </ListItem>
                        <ListItem sx={{ display: "list-item" }}>
                            <Typography>Bearbeitung von Benutzeranfragen und Transaktionen</Typography>
                        </ListItem>
                        <ListItem sx={{ display: "list-item" }}>
                            <Typography>Bereitstellung von Kundensupport</Typography>
                        </ListItem>
                        <ListItem sx={{ display: "list-item" }}>
                            <Typography>Versand von personalisierten Angeboten und Produktinformationen</Typography>
                        </ListItem>
                        <ListItem sx={{ display: "list-item" }}>
                            <Typography>Verbesserung unserer Dienste und Benutzererfahrung</Typography>
                        </ListItem>
                    </List>
                </Box>
                <Box>
                    <ListItem sx={{ display: "list-item", fontWeight: "bold" }}>
                        Weitergabe an Dritte
                    </ListItem>
                    <Typography className='pl-4'>
                        Die persönlichen Daten des Kunden werden weder an Dritte verkauft noch werden sie grundsätzlich mit Dritten ausserhalb der
                        CKW-Gruppe geteilt. Vorbehalten bleibt die Weitergabe der Daten durch CKW an externe Unternehmen oder Vertreter zur Erbringung
                        von Dienstleistungen für CKW und zu den oben erwähnten Zwecken. Diese Unternehmen und Vertreter sind verpflichtet, sich bei der
                        Nutzung der persönlichen Daten an die geltenden Gesetze und unsere Datenschutzbestimmungen zu halten.
                    </Typography>
                </Box>
                <Box>
                    <ListItem sx={{ display: "list-item", fontWeight: "bold" }}>
                        Datensicherheit
                    </ListItem>
                    <Typography className='pl-4'>
                        CKW implementiert geeignete technische und organisatorische Massnahmen zum Schutz persönlicher Daten gegen unbefugten Zugriff,
                        Offenlegung, Änderung oder Zerstörung. Für die auf Priceblick gespeicherten persönlichen Daten des Kunden gewährleistet CKW
                        eine den gesetzlichen Vorgaben entsprechende Datensicherheit.
                    </Typography>
                </Box>
                <Box>
                    <ListItem sx={{ display: "list-item", fontWeight: "bold" }}>
                        Cookies
                    </ListItem>
                    <Typography className='pl-4'>
                        CKW verwendet so genannte Cookies, um die Qualität ihrer Dienstleistungen zu verbessern und um besser verstehen zu können,
                        wie die Besucher diese Website nutzen. Cookies sind kleine Textdateien, die auf dem Gerät des Benutzers gespeichert werden
                        und die Wiedererkennung des Browsers ermöglichen. Benutzer können ihren Browser so konfigurieren, dass Cookies abgelehnt
                        oder sie benachrichtigt werden, wenn Cookies gesendet werden.
                    </Typography>
                </Box>
                <Box>
                    <ListItem sx={{ display: "list-item", fontWeight: "bold" }}>
                        Datenspeicherung
                    </ListItem>
                    <Typography className='pl-4'>
                        Persönliche Daten werden nur so lange aufbewahrt, wie es für die Zwecke, für die sie erhoben wurden, erforderlich ist
                        oder wie es das Gesetz vorschreibt. Wenn Daten nicht mehr benötigt werden, werden sie sicher gelöscht.
                    </Typography>
                </Box>
                <Box>
                    <ListItem sx={{ display: "list-item", fontWeight: "bold" }}>
                        Rechte der Betroffenen
                    </ListItem>
                    <Typography className='pl-4'>
                        Benutzer haben das Recht, Auskunft, Berichtigung, Löschung oder Einschränkung der Verarbeitung ihrer persönlichen Daten
                        zu verlangen. Sie haben auch das Recht, der Verarbeitung zu widersprechen und das Recht auf Datenübertragbarkeit.
                        Anfragen können an CKW über die unten angegebenen Kontaktdaten eingereicht werden.
                    </Typography>
                </Box>
                <Box>
                    <ListItem sx={{ display: "list-item", fontWeight: "bold" }}>
                        Kontaktinformationen
                    </ListItem>
                    <Typography className='pl-4'>
                        Bei Fragen zum Datenschutz oder zur Ausübung der Betroffenenrechte wenden Sie sich bitte an:
                    </Typography>
                    <Box pl={6} mt={2}>
                        <Typography>Centralschweizerische Kraftwerke AG</Typography>
                        <Typography>Datenschutzbeauftragter</Typography>
                        <Typography>Luzern, Schweiz</Typography>
                    </Box>
                </Box>
            </List>
            <Box pl={6} mt={2}>
                <Typography>Centralschweizerische Kraftwerke AG</Typography>
                <Typography>Luzern, Dezember 2017</Typography>
            </Box>
        </Box>
    );
}

function LiabilityContent() {
    return (
        <Box bgcolor={'white'} p={2} pr={4} pt={4} pb={4} borderRadius={1} boxShadow={1} textAlign={'justify'}>
            <Typography pl={2} variant="h6" gutterBottom>
                Haftungserklärung
            </Typography>
            <List sx={{ listStyle: "decimal", pl: 4 }}>
                <Box>
                    <ListItem sx={{ display: "list-item", fontWeight: "bold" }}>
                        Allgemeiner Haftungsausschluss
                    </ListItem>
                    <Typography className='pl-4'>
                        CKW übernimmt keine Haftung für Schäden, die dem Nutzer durch unsachgemässe Benutzung von Priceblick,
                        Verletzung der Nutzungsbedingungen oder die Nutzung von Priceblick durch nicht autorisierte Personen
                        entstehen. CKW übernimmt ferner keine Haftung für Schäden, die dem Kunden durch die Nutzung der in
                        Priceblick zur Verfügung gestellten Daten oder Informationen entstanden sind.
                    </Typography>
                </Box>
                <Box>
                    <ListItem sx={{ display: "list-item", fontWeight: "bold" }}>
                        Richtigkeit der Informationen
                    </ListItem>
                    <Typography className='pl-4'>
                        CKW bemüht sich sicherzustellen, dass die Informationen auf Priceblick genau und aktuell sind,
                        es können jedoch keine Garantien für die Richtigkeit, Vollständigkeit oder Zuverlässigkeit des
                        Inhalts übernommen werden. CKW behält sich das Recht vor, Informationen jederzeit ohne vorherige
                        Ankündigung zu ändern, zu aktualisieren oder zu entfernen.
                    </Typography>
                </Box>
                <Box>
                    <ListItem sx={{ display: "list-item", fontWeight: "bold" }}>
                        Verfügbarkeit
                    </ListItem>
                    <Typography className='pl-4'>
                        CKW übernimmt keinerlei Gewährleistung für die unterbrechungsfreie Funktionstüchtigkeit, Vollständigkeit,
                        Richtigkeit und Zuverlässigkeit von Priceblick und der darin aufbereiteten Daten. Bei der Feststellung
                        von Sicherheitsrisiken ist CKW zudem jederzeit berechtigt, den Zugang zu Priceblick zu unterbrechen oder
                        vollständig einzustellen. Der Nutzer hat keinen Anspruch auf Entschädigung irgendwelcher Art aus der rechtmässigen
                        Unterbrechung oder Einstellung des Zugangs.
                    </Typography>
                </Box>
                <Box>
                    <ListItem sx={{ display: "list-item", fontWeight: "bold" }}>
                        Inhalte von Dritten
                    </ListItem>
                    <Typography className='pl-4'>
                        Priceblick kann Links zu externen Websites oder Inhalten von Dritten enthalten. CKW hat keine Kontrolle
                        über solche externen Sites und übernimmt keine Verantwortung für deren Inhalt, Richtigkeit oder
                        Datenschutzpraktiken. Benutzer greifen auf externe Sites auf eigene Risiko zu.
                    </Typography>
                </Box>
                <Box>
                    <ListItem sx={{ display: "list-item", fontWeight: "bold" }}>
                        Datensicherheit
                    </ListItem>
                    <Typography className='pl-4'>
                        Der Kunde ist sich bewusst, dass das Internet ein offenes, für jedermann zugängliches Netz ist und im
                        Allgemeinen nicht als sichere Umgebung gilt. Demnach können die persönlichen Daten des Kunden während
                        der Übertragung über das Internet gefährdet sein. CKW implementiert geeignige Sicherheitsmassnahmen,
                        kann jedoch keine absolute Sicherheit der über das Internet übertragenen Daten garantieren.
                    </Typography>
                </Box>
                <Box>
                    <ListItem sx={{ display: "list-item", fontWeight: "bold" }}>
                        Haftungsbeschränkung
                    </ListItem>
                    <Typography className='pl-4'>
                        Soweit gesetzlich zulässig, haftet CKW nicht für indirekte, zufällige, konsequenzielle oder
                        Strafschäden, einschliesslich, aber nicht beschränkt auf Verlust von Gewinnen, Daten oder
                        Geschäftsmöglichkeiten, die sich aus oder in Verbindung mit der Nutzung von Priceblick ergeben.
                    </Typography>
                </Box>
                <Box>
                    <ListItem sx={{ display: "list-item", fontWeight: "bold" }}>
                        Schadensersatz
                    </ListItem>
                    <Typography className='pl-4'>
                        Der Benutzer erklärt sich einverstanden, CKW von allen Ansprüchen, Schäden, Verlusten oder Kosten
                        freizustellen, die sich aus der Verletzung dieser Bedingungen durch den Benutzer oder der missbräuchlichen
                        Nutzung von Priceblick ergeben.
                    </Typography>
                </Box>
                <Box>
                    <ListItem sx={{ display: "list-item", fontWeight: "bold" }}>
                        Anwendbares Recht und Gerichtsbarkeit
                    </ListItem>
                    <Typography className='pl-4'>
                        Diese Haftungsbestimmungen unterliegen schweizerischem Recht. Ausschliesslicher Gerichtsstand für
                        alle Streitigkeiten, die sich aus oder in Verbindung mit der Nutzung von Priceblick ergeben,
                        ist Luzern, Schweiz.
                    </Typography>
                </Box>
            </List>
            <Box pl={6} mt={2}>
                <Typography>Centralschweizerische Kraftwerke AG</Typography>
                <Typography>Luzern, Dezember 2017</Typography>
            </Box>
        </Box>
    );
}

export default function Disclaimer() {
    const [tabValue, setTabValue] = useState(0);

    useEffect(() => {
        document.title = `${AppName} | ${DisclaimerTitle}`;
    }, []);

    const handleChange = (event, newValue) => {
        setTabValue(newValue);
    };

    const tabs = [
        { label: 'NUTZUNGSBEDINGUNGEN', ariaLabel: 'Nutzungsbedingungen anzeigen' },
        { label: 'DATENSCHUTZ', ariaLabel: 'Datenschutz anzeigen' },
        { label: 'HAFTUNG', ariaLabel: 'Haftung anzeigen' }
    ];

    return (
        <Box sx={{ width: '100%', bgcolor: '#f5f5f5', minHeight: '100vh' }}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider', bgcolor: 'white', boxShadow: 1 }}>
                <Tabs
                    value={tabValue}
                    onChange={handleChange}
                    aria-label="disclaimer tabs"
                    variant="scrollable"
                    scrollButtons="auto"
                >
                    {tabs.map((tab, index) => (
                        <Tab
                            key={index}
                            label={tab.label}
                            aria-label={tab.ariaLabel}
                            id={`disclaimer-tab-${index}`}
                        />
                    ))}
                </Tabs>
            </Box>
            <Box sx={{ p: 2 }}>
                <TabPanel value={tabValue} index={0}>
                    <TermsOfUseContent />
                </TabPanel>
                <TabPanel value={tabValue} index={1}>
                    <PrivacyPolicyContent />
                </TabPanel>
                <TabPanel value={tabValue} index={2}>
                    <LiabilityContent />
                </TabPanel>
            </Box>
        </Box>
    );
}